import type { RouteObject } from 'react-router-dom';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import { authRoutes } from 'features/auth/routes';

// ==============================|| AUTH ROUTING ||============================== //
//
// The screens themselves come from features/auth/routes; this file only supplies the shell
// they render inside (guest guard + minimal layout + page transition).

const LoginRoutes: RouteObject = {
  path: '/',
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [...authRoutes]
};

export default LoginRoutes;
